import Vuex from 'vuex';
import Vue from 'vue';
import modules from './modules';
import advice from '../adviceConfig';

Vue.use(Vuex);


const store = new Vuex.Store({
  modules,
  plugins: [advice],
  strict: false,
});

export default store;
